import { Navigate, useLocation } from "react-router-dom";

import { Redirect } from "shared/components/Redirect";

export const RequireLoginRedirect = () => {
  const location = useLocation();
  return <Navigate to="/login" state={{ from: location }} replace />;
};

export const RedirectToHome = () => <Navigate to="/" />;

export const RedirectToOnboarding = () => <Redirect href="/onboarding" />;
